// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"ConnectBlockSubscribe_paragraph__B0_kE"};